// @ts-check
import { useCallback, useRef } from 'react';
import useEventListener from '../useEventListener';

const useClickOutside = (callback, disabled = false) => {
  if (disabled) return;

  if (typeof callback !== 'function') {
    throw new Error('useClickOutside: callback is not a function');
  }

  const element = useRef(null);

  const handleClickOutside = useCallback((event) => {
    if (element.current && !element.current.contains(event.target)) {
      callback(event);
    }
  });

  useEventListener('click', handleClickOutside, true);

  return element;
};

/* @component */
export default useClickOutside;
